export function makeProductVariant({
  id,
  productTitle = '',
  pid,
  photo,
  attendeeUId,
  eventName,
  imgUrl,
  productPurpose,
  printPool,
  shippingPrintPool,
  partialUnlockTags,
}) {
  if (!id && id !== 0) throw new Error('Should be id');
  if (!pid && pid !== 0) throw new Error('Should be pid');
  const resultVariant = {
    id,
    productTitle,
    pid,
    imgUrl,
    attendeeUid: attendeeUId,
    eventName,
    productPurpose,
  };
  if (productPurpose === 'printable' || productPurpose === 'partial_unlock_media') {
    resultVariant.photoId = photo?.id || '';
    resultVariant.occoImgUrl = photo?.thumb_full_path || '';
  }
  if (productPurpose === 'printable') {
    resultVariant.poolName = printPool;
    resultVariant.shippingPrintPool = shippingPrintPool;
  }
  if (productPurpose === 'partial_unlock_tags') {
    resultVariant.partialUnlockTags = partialUnlockTags;
  }
  return resultVariant;
}

export function makeProductsData({
  id,
  productTitle,
  anotherProductsId,
  imgUrl,
  eventName,
  attendeeUId,
  printPool,
  productPurpose,
  partialUnlockTags,
  variantId,
  shippingPrintPool,
  dTags,
  rTags,
}) {
  if (!id && id !== 0) throw new Error('Should be id');

  const variant = {
    id,
    productTitle,
    anotherProductsId,
    imgUrl,
    printPool,
    attendeeUId,
    eventName,
    productPurpose,
    partialUnlockTags,
    variantId,
    shippingPrintPool,
    tagsFilter: prepareTagsFilter(dTags, rTags),
  };

  variant.poolName = printPool;
  variant.shipmentPoolPrefix = shippingPrintPool;
  return variant;
}

export function getPidList(productsData, selectedPhotos) {
  if (productsData.anotherProductsId === Infinity) return selectedPhotos.map((_, i) => i);
  return productsData.anotherProductsId;
}

function prepareTagsFilter(dTags, rTags) {
  const acceptTags = rTags ? rTags.split(',').map((tag) => tag.trim()) : [];
  const denyTags = dTags ? dTags.split(',').map((tag) => tag.trim()) : [];
  return { acceptTags, denyTags };
}

export function makeLineItem({ variantId, variantArr }) {
  return {
    variantId,
    quantity: 1,
    customAttributes: [
      {
        key: '_variantArr',
        value: JSON.stringify(variantArr),
      },
    ],
  };
}
